import { QuoteListState } from "./rootReducerTypes";
import {
    QuoteListActionTypes,
    SET_CURRENT_PAGE, UPDATE_QUERY, SET_PAGE_SIZE, SET_SEARCH_TEXT, SET_STATUS_FILTER,
    SetCurrentPageAction,UpdateQueryAction,SetStatusFilterAction,SetPageSizeAction,SetSearchTextAction, SET_TOTAL_COUNT, SetTotalCountAction
    
} from './quoteListActionAndReducerTypes';

import { QuoteStatus } from "../enums";

// #region actions

export function setCurrentPage(currentPage: number): SetCurrentPageAction {
    return {
        type: SET_CURRENT_PAGE,
        currentPage
    };
}
export function setPageSize(pageSize: number): SetPageSizeAction {
    return {
        type: SET_PAGE_SIZE,
        pageSize
    };
}
export function updateQuery(lastQuery: string): UpdateQueryAction {
    return {
        type: UPDATE_QUERY,
        lastQuery
    };
}
export function setSearchText(searchText: string): SetSearchTextAction {
    return {
        type: SET_SEARCH_TEXT,
        searchText
    };
}

export function setTotalCount(totalCount: number): SetTotalCountAction {
    return {
        type: SET_TOTAL_COUNT,
        totalCount
    };
}
export function setStatusFilter(statusFilter: number): SetStatusFilterAction {
    return {
        type: SET_STATUS_FILTER,
        statusFilter
    };
}

// #end region actions

export default function quoteListReducer(state: QuoteListState = initialState, action: QuoteListActionTypes): QuoteListState {
    switch (action.type) {       
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.currentPage,
                skip: action.currentPage * state.pageSize,                
            };
        case UPDATE_QUERY:
            return {
                ...state,
                lastQuery: action.lastQuery,
            };
        case SET_PAGE_SIZE:
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case SET_STATUS_FILTER:
                return {
                    ...state,
                    statusFilter: action.statusFilter,
                };
        case SET_SEARCH_TEXT:
        return {
            ...state,
            searchText: action.searchText,
        };
        case SET_TOTAL_COUNT:
            return {
                ...state,
                totalCount: action.totalCount,
            };
        default:
            return state;
    }
}

export const initialState: QuoteListState = {    
    skip: 0,
    totalCount: 0,        
    lastQuery: '',
    currentPage: 0,
    pageSize: 10,    
    searchText: '',
    statusFilter: QuoteStatus.SENT
};